import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import BottomFooter from './BottomFooter';
import TopFooter from './TopFooter';
import Banners from './Banners';
import Popups from './Popups';

const Footer = () => {
  const data = useStaticQuery(graphql`{
    contentfulLayout(title: {eq: "Main"}) {
      ...Footer
    }
  }`);
  return (
    <footer>
      <TopFooter data={data}/>
      <BottomFooter data={data}/>
      <Banners data={data}/>
      <Popups data={data}/>
    </footer>
  )
}

export default Footer
